import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-and-conditions-page">
      <div className="terms-container">
        <button 
          onClick={() => navigate('/receipt-upload')}
          className="back-button"
          style={{
            marginBottom: '20px',
            padding: '8px 16px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back
        </button>
        
        <h1>Terms and Conditions</h1>
        
        <div className="terms-content">
          <section className="terms-section">
            <h2>REFUND POLICY</h2>
            <p>The Company shall not make any refunds for the lands purchased.</p>
          </section>

          <section className="terms-section">
            <h2>BUYBACK OPTION CLAUSE</h2>
            <p>
              Whereas, the Client has purchased a property from the Company, and circumstances may arise wherein the Client is no
              longer interested in maintaining ownership of said property.
            </p>
            <p>
              Whereas the Company is open to providing a buyback option to the Client, subject to the terms and conditions outlined
              herein.
            </p>
            <p>
              Now, therefore, in consideration of the mutual promises and covenants contained herein, the parties agree as follows:
            </p>
            
            <h3>1. Buyback Option:</h3>
            <p>
              <strong>1.1</strong> If the Client is no longer interested in maintaining ownership of the property, the Client shall have two
              options: (a) actively seek a buyer for the property or (b) request the Company to repurchase the property from the
              Client.
            </p>
            <p>
              <strong>1.2</strong> If the Client chooses to have the Company repurchase the property, the Client acknowledges that the
              repurchase price shall be reduced by 35% of the initial purchase sum. The initial purchase sum is defined as the
              amount agreed upon at the time the property was initially purchased.
            </p>
            
            <h3>2. Payment Terms:</h3>
            <p>
              <strong>2.1</strong> If the Client chooses the buyback option, the Company will make the payment for the property to the Client.
              This payment will be issued in staggered installments.
            </p>
            <p>
              <strong>2.2</strong> The payment installments shall commence 120 days after the signing of the Deed of Assignment, and the
              specific amounts and timeframe for each installment shall be mutually agreed upon in a separate agreement.
            </p>
            
            <h3>3. Discretionary Company Buyback:</h3>
            <p>
              <strong>3.1</strong> The Company reserves the right to decide, at its sole discretion, whether to proceed with the buyback of the
              property at any given point. The Company may discontinue the buyback option based on its assessment of market
              conditions, financial considerations, or any other factors it deems relevant.
            </p>
          </section>

          <section className="terms-section">
            <h2>RESALE CLAUSE</h2>
            <p>
              <strong>1.</strong> Clients retain the right to independently resell their property at their discretion. However, GTEXT LAND must be formally
              notified of any intended resale to enable the preparation and execution of all requisite transfer documentation.
              All associated costs relating to the transfer process, including administrative and documentation fees, shall be borne by either the
              original owner or the incoming buyer, depending on their mutual agreement.
            </p>
            <p>
              <strong>2. Full Payment Option:</strong>
            </p>
            <p>
              In instances where the new buyer remits full payment directly to the selling client, GTEXT LAND must still be duly informed to
              facilitate the legal transfer of ownership. Transfer and documentation fees are to be settled by either party, as agreed between
              them.
            </p>
            <p>
              <strong>3. Payment Split Option (Optional):</strong>
            </p>
            <p>
              Where the new buyer elects to make a partial payment, with the balance to be completed by the original owner, the transaction
              remains strictly between both parties. Nevertheless, formal notification must be provided to GTEXT LAND to process the transfer
              of ownership accordingly, and responsibility for the associated fees shall be determined by mutual agreement between the
              parties involved.
            </p>
          </section>

          <section className="terms-section">
            <h2>RELEASE CLAUSE</h2>
            <p>
              Once the agreed payment and terms of the agreement are successfully fulfilled, GTEXT LAND will transfer ownership rights
              of the property from the initial purchaser to the new buyer. Both parties agree to collaborate to ensure a smooth transfer of
              property rights.
            </p>
            <p style={{ fontStyle: 'italic', color: '#666', marginTop: '10px' }}>
              Please note that this form serves as a general template, and additional clauses or modifications may be required as per the
              specific requirements of the reselling agreement. It is advisable to consult a legal professional for a comprehensive and
              customized agreement.
            </p>
          </section>

          <section className="terms-section">
            <h2>DEFAULT CLAUSE</h2>
            <p>
              The company reserves the right to revoke the subscription where the client defaults on the payment plan for three
              months, and the property will be deemed forfeited.
            </p>
          </section>

          <section className="terms-section">
            <h2>REVOCATION CLAUSE</h2>
            <p>
              The client hereby agrees that the company reserves the right to revoke the said plot(s) if there is a default in the payment of
              the installment payment or any of the above-mentioned fees. That all cost incurred as a result of such revocation shall be
              borne by the defaulting party.
            </p>
          </section>

          <section className="terms-section">
            <h2>REALLOCATION CLAUSE</h2>
            <p>
              The Client agrees that the Company reserves the right to reallocate the Client to another estate in the event of any
              issues arising with the subscribed plots, including but not limited to changes in plot availability, zoning, or any other
              matter that may affect the Client's subscribed plot. Additionally, should the Client fail to meet the agreed-upon payment
              schedule prior to the sale of all available plots in the estate, the Company reserves the right to reallocate the Client to
              another estate that has available plots, subject to the terms and conditions of the new estate and its pricing.
            </p>
          </section>

          <section className="terms-section">
            <h2>RATIFICATION OF TITLE</h2>
            <p>
              Each client shall be solely responsible for the ratification and procurement of their individual Governor's Consent in
              accordance with applicable laws and regulations. The Company shall not be liable for any delays, costs, or obligations
              associated with the processing of the Governor's Consent, and clients are required to ensure full compliance with all
              necessary legal and administrative requirements and shall bear attendant costs arising therefrom.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
